<script setup lang="ts">

import { useAuthStore } from "@/stores/auth.ts";
import { computed } from "vue";

const authStore = useAuthStore();

const panels = [
  {
    title: "Spielergebnisse eintragen",
    description: "Hier können die Ergebnisse der Spiele eingetragen werden.",
    links: [
      { name: "Spielergebnisse", routeName: "admin.games.results" }
    ],
    modules: ['GAME_RESULT']
  }, {
    title: "Spielplan und Mannschaften",
    description: "Hier können der Spielplan und die Mannschaften verwaltet werden.",
    links: [
      { name: "Spielplan", routeName: "admin.games" },
      { name: "Gruppen", routeName: "admin.groups" },
      { name: "Mannschaften", routeName: "admin.teams" }
    ],
    modules: ['GAME_PLAN']
  }
]

const visiblePanels = computed(() => {
  return panels.filter(panel => {
    if (!panel.modules) {
      return true;
    }
    return authStore.hasAllModules(panel.modules);
  });
});

</script>

<template>
  <div class="page">
    <h2>Admin Bereich</h2>
    <p>Eingeloggt als {{authStore.account?.username}}</p>

    <div v-for="panel in visiblePanels" :key="panel.title" class="panel">
      <h3 class="text-center">{{ panel.title }}</h3>
      <p class="text-center">{{ panel.description }}</p>
      <div class="link-area">
        <router-link
          v-for="link in panel.links"
          :key="link.name"
          :to="{ name: link.routeName }"
          class="main-button"
        >
          {{ link.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>

.link-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.text-center {
  text-align: center;
}

.main-button {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: var(--main-color);
  color: var(--white);
  text-decoration: none;
  font-weight: bold;
  border-radius: 0.25rem;
  width: 10rem;
  text-align: center;
}

</style>
